import React from 'react';
import { Item, ItemDefinition, registry, RenderProps } from '../Item';
import { TEXT_WRAPPER } from '../itemIds';

export type TextWrapperAlign = 'left' | 'center' | 'right';

export interface TextWrapperProps {
  padding?: string;
  margin?: string;
  textAlign?: TextWrapperAlign;
}

export type TextWrapperDefinition = ItemDefinition<
  typeof TEXT_WRAPPER,
  TextWrapperProps
>;

export class TextWrapper extends Item<typeof TEXT_WRAPPER, TextWrapperProps> {
  protected render({
    padding,
    margin,
    textAlign,
    children
  }: RenderProps<TextWrapperProps>) {
    return (
      <div
        style={{
          padding,
          margin,
          textAlign,
          color: '#000'
        }}
      >
        {children}
      </div>
    );
  }
}

registry[TEXT_WRAPPER] = TextWrapper;
